import * as React from 'react';
import { observer } from 'mobx-react-lite';
import {
    skittleCalloutTitle,
    skittleGoPremiumButton,
    premiumPreviewCalloutTitle,
    premiumPreviewTextBeforeGoPremiumLink,
} from './SkittleCallout.locstring.json';
import loc from 'owa-localize';
import { UpsellSkittleCalloutText } from './UpsellSkittleCalloutText';
import {
    PremiumPreviewData,
    PremiumPreviewStatus,
    PremiumPreviewType,
} from '../store/schema/PremiumPreviewData';
import { logOnUpsellClicked } from '../utils/telemetry/logOnUpsellClicked';
import { Link } from '@fluentui/react/lib/Link';
import { openGoPremiumUrl } from '../utils/openGoPremiumUrl';

const styles = require('./UpsellSkittle.scss');
const EditorCalloutImage = require('../svg/EditorImage.svg');

export interface UpsellSkittleCalloutProps {
    premimumFlagsFound: number;
    premiumCategories: string;
    premiumPreviewData: PremiumPreviewData;
}

const UpsellSkittleCallout = observer(function UpsellSkittleCallout(
    props: UpsellSkittleCalloutProps
) {
    const onGoPremiumClick = React.useCallback(() => {
        openGoPremiumUrl(
            premiumPreviewData.premiumPreviewType,
            premiumPreviewData.premiumPreviewStatus,
            'Callout'
        );
        logOnUpsellClicked('Skittle', premiumPreviewData, '' /* type */);
    }, []);

    const { premimumFlagsFound, premiumCategories, premiumPreviewData } = props;
    const { premiumPreviewStatus, premiumPreviewType } = premiumPreviewData;
    const calloutTitleText =
        premiumPreviewStatus === PremiumPreviewStatus.Activated
            ? premiumPreviewCalloutTitle
            : skittleCalloutTitle;

    return (
        <div className={styles.skittleCalloutContainer}>
            <div className={styles.skittleCountContainer}>
                <div className={styles.editorImage}>
                    <img src={EditorCalloutImage} className={styles.editorSVG} />
                </div>
                <div className={styles.calloutTextContainer}>
                    <span className={styles.calloutTitle}> {loc(calloutTitleText)} </span>
                    <UpsellSkittleCalloutText
                        premimumFlagsFound={premimumFlagsFound}
                        premiumCategories={premiumCategories}
                        premiumPreviewData={premiumPreviewData}
                        upsellClicked={onGoPremiumClick}
                    />
                </div>
            </div>
            <div className={styles.linkContainer}>
                <div className={styles.linkInnerContainer}>
                    {premiumPreviewType !== PremiumPreviewType.BasicSkittle && (
                        <span className={styles.goPremiumText}>
                            {loc(premiumPreviewTextBeforeGoPremiumLink)}
                        </span>
                    )}
                    <Link
                        href={'javascript:void(0);'}
                        className={styles.goPremiumLink}
                        onClick={onGoPremiumClick}>
                        {loc(skittleGoPremiumButton)}
                    </Link>
                </div>
            </div>
        </div>
    );
});

export { UpsellSkittleCallout };
